/* TT Reels de productos
   Fase 1: carrusel con reproducción bajo demanda + agregar al carrito.
   Fase 2: modo pantalla completa (tipo TikTok) con scroll vertical y deep-link ?reel=handle.
   Rendimiento: preload="none"; los videos solo se reproducen al entrar al viewport. */
(function () {
  if (window.__ttReels) return;
  window.__ttReels = true;

  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Agregar al carrito (delegado → sirve para carrusel y clones) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tt-reel-add]');
    if (!btn) return;

    // Combo con datos ricos → abre el modal (checkboxes) en vez de agregar directo
    if (btn.getAttribute('data-combo')) {
      e.preventDefault();
      openReelCombo(btn.getAttribute('data-combo'));
      return;
    }

    var items;
    var combo = btn.getAttribute('data-combo-ids');
    if (combo) {
      items = combo.split(',').filter(Boolean).map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      if (!items.length) return;
    } else {
      if (btn.getAttribute('data-multi') === '1') {
        window.location.href = btn.getAttribute('data-url');
        return;
      }
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      items = [{ id: parseInt(id, 10), quantity: 1 }];
    }

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = '✓ Agregado';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cartcount:update'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
          var inFS = btn.closest('.tt-reels-fs');
          if (btn.closest('.tt-reel-modal')) closeInfoModal();
          if (btn.closest('.tt-reel-share')) closeMenu();
          // Desde el full-screen NO abrimos el drawer (quedaría tapado por el reel,
          // que tiene z-index alto). El contador del header ya se actualizó arriba.
          if (!inFS) {
            var openBtn = document.querySelector('.site-header-cart--button');
            if (openBtn) openBtn.click();
          }
        }, 700);
      })
      .catch(function () {
        btn.textContent = 'Error, reintenta';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
  });

  /* ---------- Modal de combo del reel (checkboxes, mismo look que la ficha) ---------- */
  var comboOverlay, comboStrip, comboList, comboCountEl, comboTotalEl, comboAddBtn, comboSoloBtn, comboCurrency;
  var comboLastFocus = null;

  function comboEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }
  function comboMoney(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: comboCurrency || 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); }
  }
  function comboRecalc() {
    var total = 0, n = 0;
    comboOverlay.querySelectorAll('[data-tt-fbt-item]').forEach(function (c) {
      if (c.checked) { total += parseInt(c.getAttribute('data-price'), 10) || 0; n++; }
    });
    if (comboTotalEl) comboTotalEl.textContent = comboMoney(total);
    if (comboCountEl) comboCountEl.textContent = n;
    if (comboAddBtn) comboAddBtn.disabled = n === 0;
  }
  function comboAdd(items, btn) {
    if (!items.length) return;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Agregando…';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = '✓ Agregado';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cartcount:update'));
        setTimeout(function () {
          closeReelCombo();
          btn.textContent = original; btn.disabled = false;
          // Desde el fullscreen NO abrimos el drawer (quedaría tapado por el reel)
          if (!document.querySelector('.tt-reels-fs.is-open')) {
            var openBtn = document.querySelector('.site-header-cart--button');
            if (openBtn) openBtn.click();
          }
        }, 700);
      })
      .catch(function () {
        btn.textContent = 'Error, reintenta';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
  }
  function closeReelCombo() {
    if (!comboOverlay) return;
    comboOverlay.classList.remove('is-open');
    document.body.classList.remove('tt-fbt-lock');
    if (comboLastFocus && comboLastFocus.focus) comboLastFocus.focus();
  }
  function comboBind() {
    if (comboOverlay) return true;
    comboOverlay = document.querySelector('[data-tt-reel-combo]');
    if (!comboOverlay) return false;
    comboStrip    = comboOverlay.querySelector('[data-tt-reel-combo-strip]');
    comboList     = comboOverlay.querySelector('[data-tt-reel-combo-list]');
    comboCountEl  = comboOverlay.querySelector('[data-tt-reel-combo-count]');
    comboTotalEl  = comboOverlay.querySelector('[data-tt-reel-combo-total]');
    comboAddBtn   = comboOverlay.querySelector('[data-tt-reel-combo-add]');
    comboSoloBtn  = comboOverlay.querySelector('[data-tt-reel-combo-solo]');
    comboCurrency = comboOverlay.getAttribute('data-currency') || 'CLP';
    var closeBtn = comboOverlay.querySelector('[data-tt-reel-combo-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeReelCombo);
    comboOverlay.addEventListener('click', function (e) { if (e.target === comboOverlay) closeReelCombo(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && comboOverlay.classList.contains('is-open')) closeReelCombo(); });
    comboOverlay.addEventListener('change', function (e) { if (e.target.matches('[data-tt-fbt-item]')) comboRecalc(); });
    if (comboAddBtn) comboAddBtn.addEventListener('click', function () {
      var items = [];
      comboOverlay.querySelectorAll('[data-tt-fbt-item]').forEach(function (c) {
        if (c.checked) items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 });
      });
      comboAdd(items, comboAddBtn);
    });
    if (comboSoloBtn) comboSoloBtn.addEventListener('click', function () {
      var main = comboOverlay.querySelector('[data-tt-fbt-main]');
      if (!main) return;
      comboAdd([{ id: parseInt(main.getAttribute('data-variant-id'), 10), quantity: 1 }], comboSoloBtn);
    });
    return true;
  }
  function openReelCombo(json) {
    if (!comboBind()) return;
    var items;
    try { items = JSON.parse(json); } catch (e) { return; }
    if (!items || !items.length) return;

    var strip = '';
    items.forEach(function (it, i) {
      if (i > 0) strip += '<span class="tt-fbt__plus" aria-hidden="true">+</span>';
      strip += '<span class="tt-fbt__ph">' + (it.img ? '<img src="' + comboEsc(it.img) + '" alt="" width="80" height="80" loading="lazy" decoding="async">' : '') + '</span>';
    });
    comboStrip.innerHTML = strip;

    var rows = '';
    items.forEach(function (it) {
      var main = !!it.main;
      rows += '<label class="tt-fbt__row' + (main ? ' tt-fbt__row--main' : '') + '">' +
        '<input type="checkbox" class="tt-fbt__check" checked' + (main ? ' disabled data-tt-fbt-main' : '') +
        ' data-tt-fbt-item data-variant-id="' + comboEsc(it.id) + '" data-price="' + comboEsc(it.p) + '">' +
        '<span class="tt-fbt__rowname">' + (main ? '<strong>Este producto:</strong> ' : '') + comboEsc(it.t) + '</span>' +
        '<span class="tt-fbt__rowprice">' + comboMoney(it.p) + '</span>' +
      '</label>';
    });
    comboList.innerHTML = rows;

    comboRecalc();
    comboLastFocus = document.activeElement;
    comboOverlay.classList.add('is-open');
    document.body.classList.add('tt-fbt-lock');
  }

  /* ---------- Mute delegado (funciona en carrusel y overlay) ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-tt-reel-mute]');
    if (!m) return;
    e.stopPropagation();
    var reel = m.closest('[data-tt-reel]');
    var video = reel && reel.querySelector('[data-tt-reel-video]');
    if (!video) return;
    video.muted = !video.muted;
    m.classList.toggle('is-muted', video.muted);
  });

  /* ---------- Modal (desktop) / bottom-sheet (móvil) con info del producto ---------- */
  var infoModal = null, infoPanel = null, infoBody = null, infoActions = null, infoOpen = false;

  function buildInfoModal() {
    if (infoModal) return;
    infoModal = document.createElement('div');
    infoModal.className = 'tt-reel-modal';
    infoModal.hidden = true;
    infoModal.innerHTML =
      '<div class="tt-reel-modal__backdrop" data-tt-modal-close></div>' +
      '<div class="tt-reel-modal__panel">' +
        '<div class="tt-reel-modal__grabber" data-tt-modal-grab aria-hidden="true"><span></span></div>' +
        '<button class="tt-reel-modal__close" data-tt-modal-close aria-label="Cerrar">✕</button>' +
        '<div class="tt-reel-modal__body" data-tt-modal-body></div>' +
        '<div class="tt-reel-modal__actions" data-tt-modal-actions hidden></div>' +
      '</div>';
    document.body.appendChild(infoModal);
    infoPanel = infoModal.querySelector('.tt-reel-modal__panel');
    infoBody = infoModal.querySelector('[data-tt-modal-body]');
    infoActions = infoModal.querySelector('[data-tt-modal-actions]');

    infoModal.querySelectorAll('[data-tt-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeInfoModal);
    });

    // Swipe-down en la agarradera (móvil) para cerrar
    var grab = infoModal.querySelector('[data-tt-modal-grab]');
    var startY = 0, dragging = false;
    grab.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY; dragging = true; infoModal.classList.add('is-dragging');
    }, { passive: true });
    grab.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var dy = e.touches[0].clientY - startY;
      if (dy > 0) infoPanel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    grab.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false; infoModal.classList.remove('is-dragging');
      var dy = e.changedTouches[0].clientY - startY;
      infoPanel.style.transform = '';
      if (dy > 90) closeInfoModal();
    });
  }

  function fmtCLP(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  }

  function openInfoModal(handle) {
    if (!handle) return;
    buildInfoModal();
    infoBody.innerHTML = '<div class="tt-reel-modal__loading">Cargando…</div>';
    infoActions.hidden = true;
    infoModal.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { infoModal.classList.add('is-open'); }); });
    infoOpen = true;
    document.addEventListener('keydown', onInfoKey);

    fetch(cartRoot + 'products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (p) {
        var price = '<b>' + fmtCLP(p.price) + '</b>';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price += ' <s>' + fmtCLP(p.compare_at_price) + '</s>';
        }
        var img = p.featured_image ? '<img class="tt-reel-modal__img" src="' + p.featured_image + '" alt="">' : '';
        infoBody.innerHTML =
          img +
          '<a class="tt-reel-modal__title" href="' + p.url + '"></a>' +
          '<div class="tt-reel-modal__price">' + price + '</div>' +
          '<div class="tt-reel-modal__desc"></div>';
        infoBody.querySelector('.tt-reel-modal__title').textContent = p.title;
        infoBody.querySelector('.tt-reel-modal__desc').innerHTML = p.description || '';

        var variant = null;
        for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { variant = p.variants[i]; break; } }
        var addBtn = variant
          ? '<button class="tt-reel-modal__add" data-tt-reel-add data-variant-id="' + variant.id + '">Agregar al carro</button>'
          : '<button class="tt-reel-modal__add" disabled>Agotado</button>';

        // Botón de favoritos (usa el wishlist del tema: SKU + endpoint)
        var sku = variant && variant.sku ? variant.sku : '';
        var cid = (window.__TTWishlistState && window.__TTWishlistState.customerId) || '';
        var favBtn = sku
          ? '<button class="tt-reel-modal__fav" data-wishlist-button data-sku="' + sku + '" data-customer-id="' + cid + '" aria-label="Agregar a favoritos">' +
              '<svg class="tt-reel-modal__fav-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-5-7.5-10.5A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 7.5 4.5C19.5 16 12 21 12 21z"/></svg>' +
            '</button>'
          : '';

        // Botón "Consultar por WhatsApp" con el producto + su link en el mensaje
        var waBtn = '';
        var waRoot = document.querySelector('[data-tt-reels][data-wa]');
        if (waRoot) {
          var waNum = waRoot.getAttribute('data-wa');
          var waMsg = waRoot.getAttribute('data-wa-msg') || 'Hola, quiero consultar por este producto:';
          var waFull = waMsg + ' ' + p.title + ' — ' + location.origin + p.url;
          var waUrl = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(waFull);
          waBtn = '<a class="tt-reel-modal__wa" href="' + waUrl + '" target="_blank" rel="noopener">' +
            '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.6 6L4 29l8.2-1.6c1.2.5 2.5.7 3.8.7C22.6 28.1 28 22.7 28 16.1 28 9.4 22.6 3 16 3Zm5.4 14.4c-.3-.2-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.4.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2-.2-.3 0-.5.1-.6l.5-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3Z"/></svg>' +
            'Consultar por WhatsApp</a>';
        }

        infoActions.innerHTML = '<div class="tt-reel-modal__row">' + addBtn + favBtn + '</div>' + waBtn;
        infoActions.hidden = false;
        // Conectar el corazón con el sistema de wishlist del tema
        if (window.ttWishlistInit) { try { window.ttWishlistInit(infoActions); } catch (e) {} }
      })
      .catch(function () {
        infoBody.innerHTML = '<div class="tt-reel-modal__loading">No se pudo cargar la info. ' +
          '<a href="' + cartRoot + 'products/' + handle + '">Ver ficha completa</a></div>';
      });
  }

  function closeInfoModal() {
    if (!infoModal || !infoOpen) return;
    infoOpen = false;
    infoModal.classList.remove('is-open');
    if (infoPanel) infoPanel.style.transform = '';
    document.removeEventListener('keydown', onInfoKey);
    setTimeout(function () { if (!infoOpen) infoModal.hidden = true; }, 360);
  }
  function onInfoKey(e) { if (e.key === 'Escape') closeInfoModal(); }

  // Trigger: tocar la tarjeta de producto del reel abre la info (fallback: ir a la ficha)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tt-reel-info]');
    if (!t) return;
    e.preventDefault();
    openInfoModal(t.getAttribute('data-reel-phandle'));
  });

  /* ---------- Menú de opciones (3 puntos): acciones del producto + compartir ---------- */
  var menuEl = null, shareUrl = '';

  function reelShareUrl(handle) {
    var base = location.origin + location.pathname;
    return handle ? base + '?reel=' + encodeURIComponent(handle) : location.href;
  }

  // Iconos SVG del menú
  function ico(d, vb) { return '<svg class="tt-menu-ico" viewBox="' + (vb || '0 0 24 24') + '" aria-hidden="true"><path d="' + d + '"/></svg>'; }
  var ICO = {
    info: ico('M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5h2v2h-2zm0 4h2v6h-2z'),
    cart: ico('M7 4H5L4 6H2v2h1.6l2.4 9h11l3-7H8.5L8 8H6zm2 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm8 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z'),
    heart: ico('M12 21s-7.5-5-7.5-10.5A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 7.5 4.5C19.5 16 12 21 12 21z'),
    share: ico('M13 5.8 15.6 8.4 17 7 12 2 7 7l1.4 1.4L11 5.8V16h2zM5 20h14v-8h-2v6H7v-6H5z'),
    wa: ico('M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.6 6L4 29l8.2-1.6c1.2.5 2.5.7 3.8.7C22.6 28.1 28 22.7 28 16.1 28 9.4 22.6 3 16 3z', '0 0 32 32'),
    link: ico('M3.9 12A3.1 3.1 0 0 1 7 8.9h4V7H7a5 5 0 0 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12zM8 13h8v-2H8zm9-6h-4v1.9h4a3.1 3.1 0 0 1 0 6.2h-4V17h4a5 5 0 0 0 0-10z'),
    flag: ico('M6 3v18H4V3zm2 1v9h11l-2-3 2-3H8z')
  };

  function closeMenu() {
    if (!menuEl) return;
    menuEl.classList.remove('is-open');
    var panel = menuEl.querySelector('.tt-reel-share__panel');
    if (panel) panel.style.transform = '';
    setTimeout(function () {
      if (menuEl && !menuEl.classList.contains('is-open')) menuEl.hidden = true;
    }, 340);
  }

  function buildMenu() {
    menuEl = document.createElement('div');
    menuEl.className = 'tt-reel-share';
    menuEl.hidden = true;
    menuEl.innerHTML =
      '<div class="tt-reel-share__backdrop" data-tt-menu-close></div>' +
      '<div class="tt-reel-share__panel">' +
        '<div class="tt-reel-share__grabber" data-tt-menu-grab aria-hidden="true"><span></span></div>' +
        '<p class="tt-reel-share__title">Opciones</p>' +
        '<div class="tt-reel-share__opts" data-tt-menu-opts></div>' +
      '</div>';
    document.body.appendChild(menuEl);
    var panel = menuEl.querySelector('.tt-reel-share__panel');
    menuEl.querySelector('[data-tt-menu-close]').addEventListener('click', closeMenu);

    var grab = menuEl.querySelector('[data-tt-menu-grab]');
    var sy = 0, drag = false;
    grab.addEventListener('touchstart', function (e) { sy = e.touches[0].clientY; drag = true; menuEl.classList.add('is-dragging'); }, { passive: true });
    grab.addEventListener('touchmove', function (e) { if (!drag) return; var dy = e.touches[0].clientY - sy; if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    grab.addEventListener('touchend', function (e) { if (!drag) return; drag = false; menuEl.classList.remove('is-dragging'); var dy = e.changedTouches[0].clientY - sy; panel.style.transform = ''; if (dy > 80) closeMenu(); });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menuEl && !menuEl.hidden) closeMenu(); });
  }

  function menuBtn(attrs, iconHtml, label, extraClass, tag) {
    tag = tag || 'button';
    return '<' + tag + ' class="tt-reel-share__opt tt-menu-act ' + (extraClass || '') + '" ' + attrs + '>' +
      iconHtml + '<span class="tt-menu-label">' + label + '</span></' + tag + '>';
  }

  function openMenu(reel) {
    if (!reel) return;
    var reelHandle = reel.getAttribute('data-reel-handle');
    shareUrl = reelShareUrl(reelHandle);
    var productHandle = reel.getAttribute('data-reel-phandle') || '';
    var variantId = reel.getAttribute('data-variant-id') || '';
    var sku = reel.getAttribute('data-product-sku') || '';
    var title = reel.getAttribute('data-product-title') || '';

    if (!menuEl) buildMenu();
    var opts = menuEl.querySelector('[data-tt-menu-opts]');
    var encText = encodeURIComponent('Mira esto 👀 ' + shareUrl);
    var waRoot = document.querySelector('[data-tt-reels][data-wa]');
    var waNum = waRoot ? waRoot.getAttribute('data-wa') : '';

    var html = '';
    // Acciones del producto
    if (productHandle) html += menuBtn('data-tt-menu-detail', ICO.info, 'Ver detalle');
    if (variantId) html += menuBtn('data-tt-reel-add data-variant-id="' + variantId + '"', ICO.cart, 'Agregar al carro');
    if (sku) {
      var cid = (window.__TTWishlistState && window.__TTWishlistState.customerId) || '';
      html += menuBtn('data-wishlist-button data-sku="' + sku + '" data-customer-id="' + cid + '"', ICO.heart, 'Guardar en favoritos', 'tt-menu-fav');
    }
    // Compartir
    html += '<div class="tt-menu-sep"></div>';
    if (navigator.share) html += menuBtn('data-tt-menu-native', ICO.share, 'Compartir con…', 'tt-reel-share__native');
    html += menuBtn('target="_blank" rel="noopener" href="https://wa.me/?text=' + encText + '"', ICO.wa, 'Compartir por WhatsApp', '', 'a');
    html += menuBtn('data-tt-menu-copy', ICO.link, 'Copiar link');
    // Reportar
    if (waNum) {
      var reportMsg = encodeURIComponent('Hola, quiero reportar un problema con este producto: ' + title + ' — ' + shareUrl);
      html += '<div class="tt-menu-sep"></div>';
      html += menuBtn('target="_blank" rel="noopener" href="https://wa.me/' + waNum + '?text=' + reportMsg + '"', ICO.flag, 'Reportar un problema', 'tt-menu-report', 'a');
    }
    opts.innerHTML = html;

    var detail = opts.querySelector('[data-tt-menu-detail]');
    if (detail) detail.addEventListener('click', function () { closeMenu(); openInfoModal(productHandle); });

    var nb = opts.querySelector('[data-tt-menu-native]');
    if (nb) nb.addEventListener('click', function () {
      navigator.share({ title: document.title || 'HerramientasTotal', text: 'Mira esto 👀', url: shareUrl }).catch(function () {});
      closeMenu();
    });

    var copyBtn = opts.querySelector('[data-tt-menu-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(shareUrl).then(function () {
        var lbl = copyBtn.querySelector('.tt-menu-label');
        if (lbl) { lbl.textContent = '✓ Link copiado'; setTimeout(function () { lbl.textContent = 'Copiar link'; }, 1500); }
      });
    });

    // Cerrar al elegir un link (WhatsApp, reportar)
    opts.querySelectorAll('a.tt-reel-share__opt').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(closeMenu, 120); });
    });

    // Conectar el corazón de favoritos con el wishlist del tema
    if (window.ttWishlistInit) { try { window.ttWishlistInit(opts); } catch (e) {} }

    menuEl.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { menuEl.classList.add('is-open'); }); });
  }

  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-tt-reel-share]');
    if (!s) return;
    e.preventDefault();
    openMenu(s.closest('[data-tt-reel]'));
  });

  ready(function () {
    var carruselReels = [].slice.call(document.querySelectorAll('[data-tt-reels-track] [data-tt-reel]'));
    if (!carruselReels.length) return;

    /* ---------- Carrusel: reproducir solo el visible (muted) ---------- */
    var ioCar = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('[data-tt-reel-video]');
        if (!video) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          video.muted = true;
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        } else { video.pause(); }
      });
    }, { threshold: [0, 0.6, 1] });
    carruselReels.forEach(function (r) { ioCar.observe(r); });

    /* ---------- Abrir pantalla completa al tocar un reel del carrusel ---------- */
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-tt-reel-toggle]');
      if (!toggle) return;
      var reel = toggle.closest('[data-tt-reel]');
      if (!reel) return;

      if (reel.closest('[data-tt-reels-fs]')) {
        // Dentro del overlay: play / pausa
        var v = reel.querySelector('[data-tt-reel-video]');
        if (!v) return;
        if (v.paused) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); reel.classList.remove('is-paused'); }
        else { v.pause(); reel.classList.add('is-paused'); }
      } else {
        // En el carrusel: abrir full-screen en este reel
        openFS(reel.getAttribute('data-reel-handle'));
      }
    });

    /* ================= Modo pantalla completa ================= */
    var fs = null, fsViewport = null, fsReels = [], ioFS = null, isOpen = false, baseUrl = null;
    var currentFSReel = null, fsMuteBtn = null, fsHint = null, hintTimer = null;

    function buildFS() {
      if (fs) return;
      fs = document.createElement('div');
      fs.className = 'tt-reels-fs';
      fs.setAttribute('data-tt-reels-fs', '');
      fs.hidden = true;
      fs.innerHTML =
        '<div class="tt-reels-fs__grabber" data-tt-reels-fs-grabber aria-hidden="true"><span></span></div>' +
        '<div class="tt-reels-fs__controls">' +
          '<button class="tt-reels-fs__ctrl" data-tt-reels-fs-close aria-label="Cerrar">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18" stroke="#fff" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg></button>' +
          '<button class="tt-reels-fs__ctrl is-muted" data-tt-fs-mute aria-label="Activar o silenciar sonido">' +
            '<svg class="tt-fs-ico tt-fs-ico--off" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm16.5 3 2.5-2.5-1.4-1.4L18 10.6 15.4 8 14 9.4l2.6 2.6L14 14.6l1.4 1.4L18 13.4l2.6 2.6 1.4-1.4L19.5 12z"/></svg>' +
            '<svg class="tt-fs-ico tt-fs-ico--on" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM14 3.2v2.1c2.9.9 5 3.5 5 6.7s-2.1 5.8-5 6.7v2.1c4-1 7-4.6 7-8.8s-3-7.8-7-8.8z"/></svg></button>' +
          '<button class="tt-reels-fs__ctrl" data-tt-fs-share aria-label="Más opciones">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>' +
        '</div>' +
        '<div class="tt-reels-fs__viewport" data-tt-reels-fs-viewport></div>' +
        '<div class="tt-reels-fs__nav" aria-hidden="true">' +
          '<button data-tt-reels-prev aria-label="Anterior">↑</button>' +
          '<button data-tt-reels-next aria-label="Siguiente">↓</button>' +
        '</div>' +
        '<div class="tt-reels-fs__hint" data-tt-fs-hint>' +
          '<svg class="tt-reels-fs__hint-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 14 12 9l5 5" stroke="#fff" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span>Desliza para ver más</span>' +
        '</div>';
      document.body.appendChild(fs);
      fsViewport = fs.querySelector('[data-tt-reels-fs-viewport]');
      fsHint = fs.querySelector('[data-tt-fs-hint]');

      // Sonido y menú (columna de controles): operan sobre el reel visible
      fsMuteBtn = fs.querySelector('[data-tt-fs-mute]');
      fsMuteBtn.addEventListener('click', function () {
        if (!currentFSReel) return;
        var v = currentFSReel.querySelector('[data-tt-reel-video]');
        if (!v) return;
        v.muted = !v.muted;
        fsMuteBtn.classList.toggle('is-muted', v.muted);
      });
      fs.querySelector('[data-tt-fs-share]').addEventListener('click', function () {
        if (currentFSReel) openMenu(currentFSReel);
      });

      // Flechas de navegación (desktop): scroll suave al reel anterior/siguiente
      fs.querySelector('[data-tt-reels-prev]').addEventListener('click', function () {
        fsViewport.scrollBy({ top: -fsViewport.clientHeight, behavior: 'smooth' });
      });
      fs.querySelector('[data-tt-reels-next]').addEventListener('click', function () {
        fsViewport.scrollBy({ top: fsViewport.clientHeight, behavior: 'smooth' });
      });

      // Agarradera: arrastrar hacia abajo para cerrar (gesto iPhone)
      var grabber = fs.querySelector('[data-tt-reels-fs-grabber]');
      var startY = 0, dragging = false;
      grabber.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY; dragging = true; fs.classList.add('is-dragging');
      }, { passive: true });
      grabber.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dy = e.touches[0].clientY - startY;
        if (dy > 0) fs.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      grabber.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false; fs.classList.remove('is-dragging');
        var dy = e.changedTouches[0].clientY - startY;
        fs.style.transform = '';
        if (dy > 110) closeFS();
      });

      // Clonar todos los reels del carrusel como slides verticales
      carruselReels.forEach(function (r) {
        var clone = r.cloneNode(true);
        clone.classList.remove('is-paused');
        fsViewport.appendChild(clone);
      });
      fsReels = [].slice.call(fsViewport.querySelectorAll('[data-tt-reel]'));

      // Reproducir con sonido solo el reel visible; actualizar el deep-link
      ioFS = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var reel = entry.target;
          var video = reel.querySelector('[data-tt-reel-video]');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
            currentFSReel = reel;
            video.muted = false;
            if (fsMuteBtn) fsMuteBtn.classList.remove('is-muted');
            var p = video.play();
            if (p && p.catch) p.catch(function () {
              video.muted = true; video.play();
              if (fsMuteBtn) fsMuteBtn.classList.add('is-muted');
            });
            reel.classList.remove('is-paused');
            var h = reel.getAttribute('data-reel-handle');
            if (h && isOpen) history.replaceState({ ttReels: true }, '', '?reel=' + encodeURIComponent(h));
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.7, 1], root: fsViewport });
      fsReels.forEach(function (r) { ioFS.observe(r); });

      fs.querySelector('[data-tt-reels-fs-close]').addEventListener('click', closeFS);
    }

    function openFS(handle) {
      buildFS();
      baseUrl = location.pathname + location.search;
      fs.hidden = false;
      // pausar el carrusel de fondo
      carruselReels.forEach(function (r) { var v = r.querySelector('[data-tt-reel-video]'); if (v) v.pause(); });
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fs.classList.add('is-open');
          var target = null;
          if (handle) {
            for (var i = 0; i < fsReels.length; i++) {
              if (fsReels[i].getAttribute('data-reel-handle') === handle) { target = fsReels[i]; break; }
            }
          }
          if (target) target.scrollIntoView();
          else if (fsReels[0]) fsReels[0].scrollIntoView();
        });
      });
      isOpen = true;
      // Hint "desliza para ver más": aparece y se oculta solo a los 3 segundos
      if (fsHint) {
        fsHint.classList.remove('is-hidden');
        clearTimeout(hintTimer);
        hintTimer = setTimeout(function () { if (fsHint) fsHint.classList.add('is-hidden'); }, 3000);
      }
      history.pushState({ ttReels: true }, '', handle ? '?reel=' + encodeURIComponent(handle) : location.href);
      document.addEventListener('keydown', onKey);
    }

    function closeFS(fromPop) {
      if (!fs || !isOpen) return;
      isOpen = false;
      fs.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      fsReels.forEach(function (r) { var v = r.querySelector('[data-tt-reel-video]'); if (v) v.pause(); });
      fs.style.transform = '';
      setTimeout(function () { if (!isOpen) fs.hidden = true; }, 360);
      if (!fromPop) {
        // Limpiar el ?reel de la URL, sin importar cómo se abrió (incluye deep-link entrante)
        try {
          var u = new URL(location.href);
          u.searchParams.delete('reel');
          history.replaceState({}, '', u.pathname + u.search + u.hash);
        } catch (err) {
          history.replaceState({}, '', baseUrl || location.pathname);
        }
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') closeFS();
      else if (e.key === 'ArrowDown') { e.preventDefault(); fsViewport.scrollBy({ top: fsViewport.clientHeight, behavior: 'smooth' }); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); fsViewport.scrollBy({ top: -fsViewport.clientHeight, behavior: 'smooth' }); }
    }

    // Botón atrás del navegador cierra el overlay
    window.addEventListener('popstate', function () {
      if (isOpen) closeFS(true);
    });

    /* ---------- Deep-link entrante: ?reel=handle abre ese reel ---------- */
    var params = new URLSearchParams(location.search);
    var wanted = params.get('reel');
    if (wanted) {
      // ¿existe ese reel en esta página?
      for (var i = 0; i < carruselReels.length; i++) {
        if (carruselReels[i].getAttribute('data-reel-handle') === wanted) { openFS(wanted); break; }
      }
    }
  });
})();
